// The last time someone used the console, shared by every tab (components/layout/IdleLogout.jsx).
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
const ACTIVE_KEY = "novus_last_active";
const IDLE_OUT_KEY = "novus_idle_signed_out";

export function markActive(force = false) {
  try {
    const now = Date.now();
    if (force || now - Number(localStorage.getItem(ACTIVE_KEY) || 0) > 5000) localStorage.setItem(ACTIVE_KEY, String(now));
  } catch {}
}
export function lastActive() {
  try { return Number(localStorage.getItem(ACTIVE_KEY) || 0) || Date.now(); } catch { return Date.now(); }
}
// A stored session whose last activity is more than 30 minutes old (the browser was closed or
// the laptop slept) has ended: AppContext drops it on load instead of opening the console.
export function sessionExpired() {
  try {
    const at = Number(localStorage.getItem(ACTIVE_KEY) || 0);
    return at > 0 && Date.now() - at >= IDLE_LIMIT_MS;
  } catch { return false; }
}
// The login page says why the user is back there.
export function markIdleSignOut(on = true) {
  try { if (on) localStorage.setItem(IDLE_OUT_KEY, "1"); else localStorage.removeItem(IDLE_OUT_KEY); localStorage.removeItem(ACTIVE_KEY); } catch {}
}
export function takeIdleSignOut() {
  try { const v = localStorage.getItem(IDLE_OUT_KEY) === "1"; localStorage.removeItem(IDLE_OUT_KEY); return v; } catch { return false; }
}
